module.exports = __webpack_public_path__ + "static/media/aliscraper-illustration.05b4701b.png";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/aliscraper-illustration.png
// module id = 2927
// module chunks = 0